import { Dispatch } from 'redux';
import { api } from '../config/api';
import { GetState } from "../config/store";
import {
    getPublicationsRequest,
    getPublicationsSuccess,
    getPublicationsFailure,
    setSearch as setSearchText,
    getVersionsRequest,
    getVersionsSuccess,
    getVersionsFailure,
    setVehicleCategory,
    getAllModelsByIdsRequest,
    getAllModelsByIdsSuccess,
    getAllModelsByIdsFailure,
    setSearchHome,
    setSeller,
    getAgentConversationRequest,
    getAgentConversationSuccess,
    getAgentConversationFailure,
    cleanAgentConversation,
    cleanPublicationFilters,
} from '../reducers/publications';
import { v4 as uuidv4 } from 'uuid';
import { cleanFilters, setVehicleType } from '../reducers/filters';
import { versionsObjectProps } from '../interfaces/app';
import { axiosClient } from '../config/axios';

// Función para normalizar acentos y caracteres especiales
const normalizeAccents = (text: string): string => {
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ñ/g, 'n')
        .replace(/Ñ/g, 'N');
};

export const getPublications = (filters: any, page?: number, limit?: number) => (dispatch: Dispatch, getState: GetState) => _getPublications(filters, page, limit, dispatch, getState);
const _getPublications = async (filters: any, page = 1, limit = 9, dispatch: Dispatch, getState: GetState) => {
    try {

        dispatch({ type: getPublicationsRequest });

        const token = getState().auth.token;
        let url = "";
        let brands = "";
        let models = "";
        let years = "";
        let colors = "";
        let fuels = "";
        let types = "";
        let dealerships = "";
        let isOportunidad = "";
        let sellers = "";

        if (filters?.brand && filters?.brand.length > 0) {
            filters.brand.forEach((brand: any) => {
                brands = brands.concat(brand.name + ",")
            })
            url = url + `${url ? '&' : ''}brand=${brands.slice(0, -1)}`;
        }

        if (filters?.dealership && filters?.dealership.length > 0) {
            filters.dealership.forEach((dealership: any) => {
                const dealershipValue = dealership.id || dealership.name || dealership;
                dealerships = dealerships.concat(dealershipValue + ",")
            })
            url = url + `${url ? '&' : ''}dealership=${dealerships.slice(0, -1)}`;
        }

        if (filters?.model && filters?.model.length > 0) {
            filters.model.forEach((model: any) => {
                models = models.concat((model.value || model.name) + ",")
            })
            url = url + `${url ? '&' : ''}model=${models.slice(0, -1)}`;
        }

        if (filters?.year && filters?.year.length > 0) {
            filters.year.forEach((year: any) => {
                years = years.concat(year + ",")
            })
            url = url + `${url ? '&' : ''}year=1,${years.slice(0, -1)}`;
        }

        if (filters?.price?.min && filters?.price?.min.length > 0 && filters?.price?.max && filters?.price?.max.length > 0) {
            url = url + `${url ? '&' : ''}price=${filters.price.min},${filters.price.max}`;
        } else {
            if (filters?.price?.min && filters?.price?.min.length > 0) url = url + `${url ? '&' : ''}price=${filters.price.min},*`;
            if (filters?.price?.max && filters?.price?.max.length > 0) url = url + `${url ? '&' : ''}price=*,${filters.price.max}`;
        }

        if (filters?.mileage && filters?.mileage.length > 0) {
            url = url + `${url ? '&' : ''}mileage=${filters.mileage[0]?.value}`;
        }

        if (filters?.color && Array.isArray(filters.color) && filters.color.length > 0) {
            filters.color.forEach((color: any) => {
                const colorValue = typeof color === 'string' ? color : color?.name || '';
                if (colorValue) {
                    colors = colors.concat(colorValue + ",");
                }
            })
            if (colors) {
                url = url + `${url ? '&' : ''}color=${colors.slice(0, -1)}`;
            }
        }

        if (filters?.fuel && Array.isArray(filters.fuel) && filters.fuel.length > 0) {
            filters.fuel.forEach((fuel: any) => {
                const fuelValue = typeof fuel === 'string' ? fuel : fuel?.name || '';
                if (fuelValue) {
                    fuels = fuels.concat(fuelValue + ",");
                }
            })
            if (fuels) {
                url = url + `${url ? '&' : ''}fuel=${fuels.slice(0, -1)}`;
            }
        }

        if (filters?.region && Array.isArray(filters.region) && filters.region.length > 0) {
            let regions = "";
            filters.region.forEach((region: any) => {
                const regionValue = typeof region === 'string' ? region : region?.name || '';
                if (regionValue) {
                    regions = regions.concat(regionValue + ",");
                }
            })
            if (regions) {
                url = url + `${url ? '&' : ''}region=${encodeURIComponent(regions.slice(0, -1))}`;
            }
        }

        if (filters?.transmission && Array.isArray(filters.transmission) && filters.transmission.length > 0 && filters.transmission.length < 3) {
            let transmissions = "";
            filters.transmission.forEach((transmission: any) => {
                const transmissionValue = typeof transmission === 'string' ? transmission : transmission?.name || '';
                if (transmissionValue) {
                    transmissions = transmissions.concat(transmissionValue + ",");
                }
            })
            if (transmissions) {
                url = url + `${url ? '&' : ''}transmission=${transmissions.slice(0, -1)}`;
            }
        }

        if (filters?.seller && filters?.seller.length > 0 && filters?.seller.length < 2) {
            filters.seller.forEach((seller: any) => {
                const sellerMap: { [key: string]: string } = {
                    'Particular': 'C2C',
                    'Concesionario': 'B2C'
                };
                const mappedSeller = sellerMap[seller];
                if (mappedSeller) {
                    sellers = sellers.concat(mappedSeller + ",");
                }
            })
            if (sellers) {
                url = url + `${url ? '&' : ''}business_type=${sellers.slice(0, -1)}`;
            }
        }

        // Si es oportunidad, enviar condition=all para traer todos los autos
        if (filters?.isOportunidad) {
            url = url + `${url ? '&' : ''}condition=all`;
        } else if (filters?.vehicle_type === 'new') {
            url = url + `${url ? '&' : ''}condition=new`;
        } else if (filters?.vehicle_type === 'used') {
            url = url + `${url ? '&' : ''}condition=used`;
        }

        if (filters?.type && filters?.type.length > 0) {
            filters?.type.forEach((type: any) => {
                const normalizedType = normalizeAccents(type);
                types = types.concat(normalizedType + ",")
            })
            url = url + `${url ? '&' : ''}type=${types.slice(0, -1)}`;
        }

        const shouldSkipTypeArticle = filters?.vehicle || (filters?.vehicleCategory && filters.vehicleCategory.length === 2);

        if (!shouldSkipTypeArticle) {
            let typeArticle = 'vehicles';

            if (filters?.vehicleCategory && filters?.vehicleCategory.length > 0) {
                const categoryMap: { [key: string]: string } = {
                    'Autos': 'vehicles',
                    'Comerciales': 'trucks'
                };
                typeArticle = categoryMap[filters.vehicleCategory[0]] || 'vehicles';
            }

            url = url + `${url ? '&' : ''}type_articles=${typeArticle}`;
        }

        if (filters?.text && filters?.text.length > 0) {
            url = url + `${url ? '&' : ''}text=${filters?.text}`;
        }

        if (filters?.order && filters?.order !== "relevancia") {
            url = url + `${url ? '&' : ''}order=${filters?.order}`;
        }

        if (filters?.isOportunidad) {
            url = url + `${url ? '&' : ''}opportunity=true`;
        }
        //TODO esto por que esta aca no tiene sentido
        //   if (url) {
        //       url = url + "&";
        //  }

        const response = await axiosClient.get(`${api.publications}/search?page=${page}&limit=${limit}&fallback=true&pictures=original&${url}`);

        dispatch({
            type: getPublicationsSuccess,
            payload: {
                publications: response?.data.data.publications,
                total: response?.data.data.total,
                found: response?.data.data.found,
                page,
                limit,
                suggested: Boolean(filters?.suggested)
            }
        });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getPublicationsFailure });
    }
}

export const cleanFiltersReducer = () => (dispatch: Dispatch) => _cleanFiltersReducer(dispatch);
const _cleanFiltersReducer = (dispatch: Dispatch) => {
    dispatch({ type: cleanFilters.type });
    dispatch({ type: cleanPublicationFilters.type });
};

export const setSearchReducer = (text: string) => (dispatch: Dispatch) => _setSearchReducer(text, dispatch);
const _setSearchReducer = (text: string, dispatch: Dispatch) => dispatch({ type: setSearchText, payload: text });

export const getVersions = (versionsObject: versionsObjectProps) => (dispatch: Dispatch) => _getVersions(versionsObject, dispatch);
const _getVersions = async (versionsObject: versionsObjectProps, dispatch: Dispatch) => {
    try {
        dispatch({ type: getVersionsRequest });

        const response = await axiosClient.post(`${api.autoRed}/versions`, versionsObject);

        dispatch({ type: getVersionsSuccess, payload: response?.data });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getVersionsFailure });
    }
}

export const setVehicleTypeReducer = (vehicleType: string) => (dispatch: Dispatch) => _setVehicleTypeReducer(vehicleType, dispatch);
const _setVehicleTypeReducer = (vehicleType: string, dispatch: Dispatch) => dispatch({ type: setVehicleType, payload: vehicleType });

export const setVehicleCategoryReducer = (vehicleCategory: string[]) => (dispatch: Dispatch) => _setVehicleCategoryReducer(vehicleCategory, dispatch);
const _setVehicleCategoryReducer = (vehicleCategory: string[], dispatch: Dispatch) => dispatch({ type: setVehicleCategory, payload: vehicleCategory });

export const setSearchHomeReducer = (searchText: string) => (dispatch: Dispatch) => _setSearchHomeReducer(searchText, dispatch);
const _setSearchHomeReducer = (searchText: string, dispatch: Dispatch) => dispatch({ type: setSearchHome, payload: searchText });

export const getAllModelsByIds = (ids: string[]) => (dispatch: Dispatch) => _getAllModelsByIds(ids, dispatch);
const _getAllModelsByIds = async (ids: string[], dispatch: Dispatch) => {
    try {
        dispatch({ type: getAllModelsByIdsRequest });

        const promises = ids.map(id => axiosClient.get(`${api.autoRed}/models/${id}`));

        const responses = await Promise.all(promises);

        const allModels = responses.flatMap(response => response?.data || []);

        dispatch({ type: getAllModelsByIdsSuccess, payload: allModels });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getAllModelsByIdsFailure });
    }
};

export const setSellerReducer = (seller: string[]) => (dispatch: Dispatch) => _setSellerReducer(seller, dispatch);
const _setSellerReducer = (seller: string[], dispatch: Dispatch) => dispatch({ type: setSeller, payload: seller });

export const getAgentConversation = (busqueda: string) => (dispatch: Dispatch, getState: GetState) => _getAgentConversation(busqueda, dispatch, getState);
const _getAgentConversation = async (busqueda: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getAgentConversationRequest });

        // Generar un nuevo caseId (UUID) para cada query
        const caseId = uuidv4();

        const body = JSON.stringify({
            message: {
                type: "text",
                content: busqueda
            },
            caseId,
            sync: true
        });

        const response = await axiosClient.post(
            `${api.agents}/conversations/6970dae8c5673fe86042e06d`,
            body,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'ApiKey 080FC782-ED56-4EC5-AAB6-8015C3F68E5D'
                }
            }
        );

        dispatch({ type: getAgentConversationSuccess, payload: response?.data });

        return response?.data;

    } catch (error: any) {
        console.log("getAgentConversation error", error);
        const errorResponse = error?.response?.data?.error;
        dispatch({ type: getAgentConversationFailure });
    }
};

export const cleanAgentConversationReducer = () => (dispatch: Dispatch) => _cleanAgentConversationReducer(dispatch);
const _cleanAgentConversationReducer = (dispatch: Dispatch) => dispatch({ type: cleanAgentConversation });

